export const BUNDLE_MAX_THICKNESS_MARKER = 48;
